var map = {
	"./404/404.js": "./src/patterns/components/404/404.js",
	"./advertising-progressbar/advertising-progressbar.js": "./src/patterns/components/advertising-progressbar/advertising-progressbar.js",
	"./advertising/advertising.js": "./src/patterns/components/advertising/advertising.js",
	"./anchor-content/anchor-content.js": "./src/patterns/components/anchor-content/anchor-content.js",
	"./animation/animation.js": "./src/patterns/components/animation/animation.js",
	"./bubbles/bubbles.js": "./src/patterns/components/bubbles/bubbles.js",
	"./button-group/button-group.js": "./src/patterns/components/button-group/button-group.js",
	"./button/button.js": "./src/patterns/components/button/button.js",
	"./collapse/collapse.js": "./src/patterns/components/collapse/collapse.js",
	"./container/container.js": "./src/patterns/components/container/container.js",
	"./custom-select/custom-select.js": "./src/patterns/components/custom-select/custom-select.js",
	"./favorite-song/favorite-song.js": "./src/patterns/components/favorite-song/favorite-song.js",
	"./featured-image/featured-image.js": "./src/patterns/components/featured-image/featured-image.js",
	"./featured-label/featured-label.js": "./src/patterns/components/featured-label/featured-label.js",
	"./footer/footer.js": "./src/patterns/components/footer/footer.js",
	"./form/form.js": "./src/patterns/components/form/form.js",
	"./frequencies/frequencies.js": "./src/patterns/components/frequencies/frequencies.js",
	"./gravityforms/gravityforms.js": "./src/patterns/components/gravityforms/gravityforms.js",
	"./header/header.js": "./src/patterns/components/header/header.js",
	"./helpers/helpers.js": "./src/patterns/components/helpers/helpers.js",
	"./icon/icon.js": "./src/patterns/components/icon/icon.js",
	"./image/image.js": "./src/patterns/components/image/image.js",
	"./label-value/label-value.js": "./src/patterns/components/label-value/label-value.js",
	"./link/link.js": "./src/patterns/components/link/link.js",
	"./list-icons/list-icons.js": "./src/patterns/components/list-icons/list-icons.js",
	"./list-logos/list-logos.js": "./src/patterns/components/list-logos/list-logos.js",
	"./list/list.js": "./src/patterns/components/list/list.js",
	"./listen/listen.js": "./src/patterns/components/listen/listen.js",
	"./loader/loader.js": "./src/patterns/components/loader/loader.js",
	"./main/main.js": "./src/patterns/components/main/main.js",
	"./nav/nav.js": "./src/patterns/components/nav/nav.js",
	"./news/news.js": "./src/patterns/components/news/news.js",
	"./on-air/on-air.js": "./src/patterns/components/on-air/on-air.js",
	"./overlayscrollbars/overlayscrollbars.js": "./src/patterns/components/overlayscrollbars/overlayscrollbars.js",
	"./player/player.js": "./src/patterns/components/player/player.js",
	"./prize-games/prize-games.js": "./src/patterns/components/prize-games/prize-games.js",
	"./reset/reset.js": "./src/patterns/components/reset/reset.js",
	"./section/section.js": "./src/patterns/components/section/section.js",
	"./show/show.js": "./src/patterns/components/show/show.js",
	"./slider-currently-playing/slider-currently-playing.js": "./src/patterns/components/slider-currently-playing/slider-currently-playing.js",
	"./slider-scroller/slider-scroller.js": "./src/patterns/components/slider-scroller/slider-scroller.js",
	"./slider/slider.js": "./src/patterns/components/slider/slider.js",
	"./table/table.js": "./src/patterns/components/table/table.js",
	"./tabs/tabs.js": "./src/patterns/components/tabs/tabs.js",
	"./text/text.js": "./src/patterns/components/text/text.js",
	"./two-columns/two-columns.js": "./src/patterns/components/two-columns/two-columns.js",
	"./typography/typography.js": "./src/patterns/components/typography/typography.js",
	"./wordpress/wordpress.js": "./src/patterns/components/wordpress/wordpress.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/patterns/components sync recursive ^\\.\\/(?%21.*admin).*\\.js$";